import { AdContainer } from '../../ad-container/ad-container';
import { ParametersExtractor } from '../../parameters-extractor/parameters-extractor';
import { ViewabilityObserver } from '../../types/viewability-observer';
import { IntersectionObserverService } from './dom/intersection-observer-service';
import { MraidObserverService } from './mraid/mraid-observer-service';

export class ViewabilityObserverFactory {
  private static readonly MRAID_ENV_VAR_NAME: string = 'MRAID_ENV';

  constructor(
    private readonly aWindow: Window,
    private readonly adContainer: AdContainer,
    private readonly parameterExtractor: ParametersExtractor
  ) {}

  public getViewabilityObserver(): ViewabilityObserver {
    const mraidEnv: {
      mwebFlag: boolean;
    } = this.parameterExtractor.getWindowVariable<{ mwebFlag: boolean }>(
      ViewabilityObserverFactory.MRAID_ENV_VAR_NAME,
      this.aWindow
    );

    if (mraidEnv && mraidEnv.mwebFlag === true) {
      // In Ogury Web, rely on IntersectionObserver
      return new IntersectionObserverService();
    }

    // Else, rely on MRAID Presence
    if (this.aWindow.mraid) {
      return new MraidObserverService(this.adContainer);
    }

    return new IntersectionObserverService();
  }
}
